import { Link } from "react-router-dom";
import HomeIcon from '@mui/icons-material/Home';

function PageHeaderWithBreadcrumbs ({ title, breadcrumb, includeButton }) {
  return (
    <div className="page-header-container">
    <div className="page-header-contents">
      <h1>{title}</h1>
        <ul>
            <li className="db-link"><Link to="/"><HomeIcon/> Dashboard</Link></li> 
            <li>{breadcrumb}</li>
        </ul>
    </div>
    {includeButton == "555" ? 
    <Link to="/users/new" className="link">
    Add New
    </Link>
    : "" }
    </div>
  );
};

export default PageHeaderWithBreadcrumbs;